import { __rest } from "tslib";
import { Button } from "antd";
import { Field } from "formik";
import * as React from "react";
export var SubmitButton = function SubmitButton(_a) {
  var children = _a.children,
      onSuccess = _a.onSuccess,
      restProps = __rest(_a, ["children", "onSuccess"]);

  return React.createElement(Field, null, function (_ref) {
    var _ref$form = _ref.form,
        isSubmitting = _ref$form.isSubmitting,
        isValid = _ref$form.isValid;
    return React.createElement(Button, Object.assign({
      loading: isSubmitting,
      disabled: !isValid || isSubmitting,
      type: "primary",
      htmlType: "submit"
    }, restProps), children);
  });
};
export default SubmitButton;